const assetData = [
  {
    assetDetails: {
      brandName: "Flowscan.io",
      description: "Flowscan is a blockchain explorer for the Flow blockchain.",
      website: "https://flowscan.io",
    },
    assets: [
      { name: "Logo light", src: "/assets/flowscan/logo.png" },
      { name: "Logo dark", src: "/assets/flowscan/logo_dark.png" },
      { name: "icon", src: "/assets/flowscan/icon.png" },
      { name: "icon dark", src: "/assets/flowscan/icon_dark.png" },
    ],
  },
  {
    assetDetails: {
      brandName: "Find Labs",
      description:
        "Logo's for Find Labs. To be used in presentations, documents, etc.",
      website: "https://findlabs.io",
    },
    assets: [
      { name: "Logo", src: "/assets/findlabs/logo.png" },
      { name: "Icon", src: "/assets/findlabs/icon.png" },
    ],
  },
  {
    assetDetails: {
      brandName: "Flow",
      description:
        "Flow is a fast, decentralized, and developer-friendly blockchain.",
      website: "https://flow.com",
    },
    assets: [{ name: "Logo", src: "/assets/flow/flow-logo.png" }],
  },
  {
    assetDetails: {
      brandName: "CryptoKitties",
      description:
        "CryptoKitties is a blockchain-based virtual game that allows players to purchase, collect, breed, and sell virtual cats.",
      website: "https://www.cryptokitties.co",
    },
    assets: [
      { name: "Icon", src: "/assets/blockscout/tokens/bartholomeow.png" },
      { name: "Icon", src: "/assets/blockscout/tokens/catseye.png" },
      { name: "Icon", src: "/assets/blockscout/tokens/gwendolion.png" },
      { name: "Icon", src: "/assets/blockscout/tokens/hotcocoa.png" },
      { name: "Icon", src: "/assets/blockscout/tokens/pawderick.png" },
      { name: "Icon", src: "/assets/blockscout/tokens/purrzival.png" },
    ],
  },
];

export default assetData;
